import { PublicHolidaysService } from "../../services";
import { createCRUDThunksLegacy } from "../../shared/helpers";

const service = new PublicHolidaysService();
export const publicHolidaysThunks = createCRUDThunksLegacy({
  service,
  resourceName: "public-holidays",
});
